import { $, _, Backbone, Radio, Foundation, moment, Datepicker } from "../../../vendor";
import InboomaBaseView from "../InboomaBaseView";
import InboomaBaseCollectionView from "../InboomaBaseCollectionView";

import { Notification, Backform, FormatHelper, Biscuit } from "../../utils";
import Inboomai18n from "../../utils/Inboomai18n";
import { getApiHost, getRequestHeaders } from "../../Sync";

import ContingentPlans from "../../collections/ContingentPlans";

import { appPlantoolCollectionEmptyTpl, appRollingLoaderAnim } from "../AppAnnouncements";
import PlantoolItemWrapperTpl from "../../templates/contingents/PlantoolItemWrapperTpl.html";
import PlantoolItemTpl from "../../templates/contingents/PlantoolItemTpl.html";
import PlantoolSidebarTpl from "../../templates/contingents/PlantoolSidebarTpl.html";
import PlantoolSortTabsTpl from "../../templates/contingents/PlantoolSortTabsTpl.html";
import SidebarFilterBehavior from "../../behaviors/Behavior.SidebarFilter";
import ContingentPlan from "../../models/ContingentPlan";

/**
 * Contingent- and Network-plantool
 *
 * Called from ContingentsController with essential parameter "isNetworkPlan" [bool]
 *
 * Absence of jQuery: Coverage >95% ^^
 *
 * Hierarchy:
 *
 * PlantoolView [InboomaBaseCollectionView]
 *  -> PlantoolViewItemList [InboomaBaseCollectionView]
 *     -> PlantoolViewItem [InboomaBaseView]
 *
 * @todo as activePlanData refers to a locally required state,
 * we should make it a model which is attached to PlantoolSidebar
 * so that toggling between view-mode's re-renders sidebar automatically
 */

let activePlanData = null; // State set by plantoolForm; @todo see above

const PlantoolViewItem = InboomaBaseView.extend({
  template: PlantoolItemTpl,

  ui: {
    numberTargetInput: "input.number_target",
    numberDifference: "span.number_difference",
    numberDefects: 'input[name="number_defects"]',
    numberAvailablePreviousDay: 'input[name="number_available_previous_day"]',
    validToDateField: 'input[name="valid_to_date_field"]',
    validToTimeField: 'input[name="valid_to_time_field"]',
    available: "a.available",
    reserve: "span.reserve",
    availableText: "span.available",
  },

  events: {
    "change @ui.numberTargetInput": "_changeNumberTarget",
    "change @ui.numberDefects": "_changeNumberTarget",
    "change @ui.numberAvailablePreviousDay": "_changeNumberTarget",
    "focusout @ui.validToTimeField": "_setValidToTime",
  },

  templateContext() {
    let itemCount = this.getOption("itemCount");
    return {
      itemsSelectedLocationCount: this.getOption("itemsSelectedLocationCount"),
      itemCount: itemCount++,
      date: this._date,
      isSavedItem: this.getOption("isSavedItem"),
      networks: this.getOption("networks"),
      isNetworkPlan: this.getOption("isNetworkPlan"),
      targetPlanIsEmpty: activePlanData === null,
      client_id: Biscuit.get("user.client_id"),
    };
  },

  _changeNumberTarget(event) {
    const diffClass = "number_difference number_target",
      defectName = "number_defect",
      avPrevName = "number_available_previous_day";
    // We do NOT want to override model state so that user gets possibility to unset
    // his changes to the previous stage -> get state from input field(s)
    let difference = 0;
    this.model.set("valid_to", this._date.format("YYYY-MM-DD HH:mm:00"));
    let target = 0;

    if (this.getOption("isNetworkPlan")) {
      target = Number(this.getUI("numberTargetInput")[0].value);
      difference = Number(
        Number(
          this.model.get("number_checkins") -
            Number(this.getUI("numberAvailablePreviousDay")[0].value),
        ),
      );
    } else {
      target = Number(this.getUI("numberTargetInput")[0].value);
      difference = Number(target) - Number(this.model.get("number_available"));
    }

    let location =
        typeof this.model.get("location") !== "undefined"
          ? this.model.get("location")
          : this.getOption("location"),
      location_id =
        typeof this.model.get("location_id") !== "undefined"
          ? this.model.get("location_id")
          : this.getOption("location_id"),
      number_target = target,
      number_difference = difference,
      number_defects = Number(this.getUI("numberDefects")[0].value),
      number_available_previous_day = Number(this.getUI("numberAvailablePreviousDay")[0].value);
    let change_type = "";

    if (number_difference < 0) {
      change_type = "decrease";
    } else if (number_difference === 0) {
      change_type = "neutral";
    } else {
      change_type = "increase";
    }
    if (this.getOption("isNetworkPlan")) {
      let change_type_2 = "";
      let reserve = Number(
        Number(this.getUI("numberAvailablePreviousDay")[0].value) -
          this.model.get("number_checkins") -
          Number(this.getUI("numberDefects")[0].value),
      );

      if (reserve > 0) {
        difference = target;
      } else {
        difference = Number(
          Number(this.getUI("numberAvailablePreviousDay")[0].value) -
            this.model.get("number_checkins") -
            Number(this.getUI("numberDefects")[0].value),
        );
      }
      let notChoosen = false;

      if (event.target.className === diffClass) {
        let tester =
          difference +
            Number(
              Number(this.getUI("numberAvailablePreviousDay")[0].value) -
                this.model.get("number_checkins") -
                Number(this.getUI("numberDefects")[0].value),
            ) <
          0;

        if (!tester) {
          difference = target;
        } else {
          difference = Number(this.getUI("numberAvailablePreviousDay")[0].value) * -1;
        }

        notChoosen = true;
      }

      if (difference < 0) {
        if (notChoosen) {
          change_type = "increase";
          reserve -= difference * -1;
        } else {
          change_type = "decrease";
          difference *= -1;
          reserve -= difference;
        }
      } else if (difference === 0) {
        change_type = "neutral";
        reserve += difference;
      } else {
        change_type = "decrease";
        reserve += difference;
      }
      if (reserve < 0) {
        change_type_2 = "neutral";
        reserve = 0;
        if (notChoosen && difference < 0) {
          difference++;
          if (difference < 0) {
            change_type = "increase";
          } else if (difference === 0) {
            change_type = "neutral";
          } else {
            change_type = "decrease";
          }
        }
      } else if (reserve === 0) {
        change_type_2 = "neutral";
      } else {
        change_type_2 = "increase";
      }
      let available = Number(
        Number(this.getUI("numberAvailablePreviousDay")[0].value) +
          difference -
          Number(this.getUI("numberDefects")[0].value),
      );
      if (target < 0) {
        available = Number(
          Number(this.getUI("numberAvailablePreviousDay")[0].value) -
            difference -
            Number(this.getUI("numberDefects")[0].value),
        );
      }
      this.getUI("numberTargetInput")[0].setAttribute("data-change-type", change_type);

      this.getUI("numberTargetInput")[0].innerText = `${difference}`;
      this.getUI("numberTargetInput")[0].value = difference;
      this.getUI("reserve")[0].setAttribute("data-change-type", change_type_2);
      this.getUI("reserve")[0].innerText = `${reserve}`;
      if ($(".availableText").length > 0) {
        this.getUI("availableText")[0].innerText = `${available}`;
      }

      number_target = difference;
    } else {
      this.getUI("numberDifference")[0].setAttribute("data-change-type", change_type);
      this.getUI("numberDifference")[0].innerText = `(${number_difference})`;
    }

    if (
      !this.getOption("isNetworkPlan") &&
      number_difference === 0 &&
      !this.getOption("isSavedItem")
    ) {
      this.getOption("plantoolView").removeTargetPlanItem(
        location_id,
        this.model.get("contingent_id"),
      );
    } else {
      this.getOption("plantoolView").setTargetPlanItem(
        location_id,
        Number(this.model.get("contingent_id")),
        {
          ...this.model.attributes,
          location,
          change_type,
          number_target,
          number_defects,
          number_available_previous_day,
        },
      );
    }
  },

  _setValidToTime() {
    const val = this.getUI("validToTimeField")[0].value;

    if (val.length === 2 && val.indexOf(":") === -1) {
      // User typed e.g. "12" -> make "12:00", then re-check
      this.getUI("validToTimeField")[0].value = val + ":00";
      this._setValidToTime();
      return;
    }

    const valSplitted = val.split(":");

    if (
      valSplitted.length === 2 &&
      valSplitted[0].length === 2 &&
      valSplitted[1].length === 2 &&
      Number(valSplitted[0]) <= 23 &&
      Number(valSplitted[1]) <= 59
    ) {
      this._date.set("hour", Number(valSplitted[0])).set("minute", Number(valSplitted[1]));

      this._changeNumberTarget();
    } else {
      // Reset previous, valid time value
      this.getUI("validToTimeField")[0].value = this._date.format("HH:mm");
    }
  },

  initialize() {
    this._date =
      typeof this.model.get("valid_to") !== "undefined"
        ? moment(this.model.get("valid_to"))
        : activePlanData.valid_to.clone();

    // @todo On initial rendering, contingentPlansCollection
    // lacks some attributes -> save those in database!

    if (typeof this.model.attributes.contingent === "undefined") {
      this.model.attributes.contingent = "";
    }

    if (typeof this.model.attributes.number_target === "undefined") {
      this.model.attributes.number_target = this.model.attributes.number_available;
      if (this.getOption("isNetworkPlan")) {
        this.model.attributes.number_target = 0;
      }
    }

    if (typeof this.model.attributes.change_type === "undefined") {
      this.model.attributes.change_type = "none";
    }

    if (
      typeof this.model.attributes.number_defects === "undefined" ||
      this.model.attributes.number_defects === null
    ) {
      this.model.attributes.number_defects = 0;
    }

    if (
      typeof this.model.attributes.number_total === "undefined" ||
      this.model.attributes.number_total === null
    ) {
      this.model.attributes.number_total = 0;
    }

    delete this.model.attributes.t;
  },

  onRender() {
    const that = this,
      datepicker = new Datepicker({
        format: "D. MMMM YYYY",
        field: this.getUI("validToDateField")[0],
        i18n: Inboomai18n.getPikadayI18n(),
        firstDay: 1, // monday
        minDate:
          activePlanData && typeof activePlanData.valid_from !== "undefined"
            ? activePlanData.valid_from.toDate()
            : null,
        onSelect() {
          const newDate = this.getMoment().format("YYYY-MM-DD").split("-");

          that._date
            .set("year", Number(newDate[0]))
            .set("month", Number(newDate[1]) - 1)
            .set("date", Number(newDate[2]));

          that._changeNumberTarget();
        },
      });
  },
});

const PlantoolViewItemList = InboomaBaseCollectionView.extend({
  template: PlantoolItemWrapperTpl,

  ui: {
    dropdownLink: ".inb-toggle-menu-dd",
    dropdown: ".inb-dropdown",
    edit: ".inb-plan-item__edit",
    remove: ".inb-plan-item__remove",
    reset: ".inb-plan-item__reset",
    toggle: ".inb-toggle-details",
  },

  events: {
    "click @ui.dropdownLink": "_initDropdown",
    "click @ui.remove": "_remove",
    "click @ui.edit": "_edit",
    "click @ui.reset": "_reset",
    "click @ui.toggle": "_toggle",
  },

  className: "inb-c-item inb-c-item--plantool row",
  childView: PlantoolViewItem,
  childViewContainer: ".plantool-items",

  // @todo i18n
  collectionEmptyTpl: `<p style="margin:0 auto;padding-bottom:15px;">- No contingents -</p>`,

  templateContext() {
    let itemNetwork = null;
    if (this.getOption("isNetworkPlan")) {
      let networks = Radio.channel("networks").request("get:data");
      let network_id = getContingentPlanNetworkId(this.model);
      if (network_id && typeof networks._byId[network_id] !== "undefined") {
        itemNetwork = networks._byId[network_id];
      }
    }

    return {
      formattedDate:
        typeof this.model.get("date") !== "undefined"
          ? moment(this.model.get("date")).format("D. MMMM YYYY")
          : null,
      itemNetworkName: itemNetwork ? itemNetwork.get("name") : null,
      isNetworkPlan: this.getOption("isNetworkPlan"),
    };
  },

  _itemCount: -1,

  childViewOptions() {
    let networks = null;

    if (this.getOption("isNetworkPlan")) {
      networks = Radio.channel("networks").request("get:data");
    }

    return {
      plantoolView: this.getOption("plantoolView"),
      location: this.model.get("location"),
      location_id: this.model.get("location_id"),
      isSavedItem: this.model.get("isSavedItem"),
      contingentPlanID: this.model.get("id"),
      isNetworkPlan: this.getOption("isNetworkPlan"),
      network_id: this.model.get("network_id"),
      itemCount: this._itemCount,
      networks,
    };
  },

  onRender() {
    // We actually prevent this row to be displayed in DOM
    // Achieving this via this.getTemplate() and other hooks did NOT work
    // as they were called/initialized only once
    const isNetworkPlanContext = this.getOption("isNetworkPlan");

    let itemNetworkId = isNetworkPlanContext ? getContingentPlanNetworkId(this.model) : null;

    if (
      (!isNetworkPlanContext && this.model.get("type") === "network") ||
      (isNetworkPlanContext && this.model.get("type") === "contingent") ||
      (isNetworkPlanContext &&
        this.filterNetwork &&
        itemNetworkId &&
        itemNetworkId !== this.filterNetwork)
    ) {
      this.$el[0].classList.add("hide");
    } else {
      this.$el[0].classList.remove("hide");
    }
  },

  initialize() {
    this.filterNetwork = null;

    if (typeof this.model.get("location") === "undefined") {
      this.model.set("location", this.model.get("location_id"));
    }

    if (typeof this.model.get("id") === "undefined") {
      // For Foundation.Dropdown to work properly
      this.model.set("id", _.uniqueId("plan_item"));
    }

    this.model.set("isSavedItem", typeof this.model.get("contingent_plan_items") !== "undefined");

    if (this.model.get("isSavedItem")) {
      /* if (typeof this.model.get('contingent_plan_items')[0] !== 'undefined') {
              this.model.set('location', this.model.get('contingent_plan_items')[0].location);
          }*/
    }

    this.collection = new Backbone.Collection(
      this.model.get("isSavedItem")
        ? this.model.get("contingent_plan_items")
        : this.model.get("items"),
    );

    if (this.model.get("isSavedItem")) {
      // Sort list by locations alphabetically and by contingent alphabetically
      this.collection.comparator = (item) => [item.get("location"), item.get("contingent")];
      this.collection.sort();
    }

    const appChannel = Radio.channel("app");

    appChannel.on("plantool-items:filter", (e) => {
      this.filterNetwork = e.network_id;
      this.render();
    });
  },

  _initDropdown(ev) {
    ev.preventDefault();

    this._dropdown = new Foundation.Dropdown(this.getUI("dropdown"));

    this._dropdown.open();

    return false;
  },

  _reset() {
    this.getOption("plantoolView").removeTargetPlanItem(this.model.get("location_id"));

    this.render();
  },

  _remove() {
    const that = this;

    if (confirm(this.t("really_remove"))) {
      this.model.destroy({
        success() {
          that.$el.fadeOut("fast");

          new Notification({
            message: that.t("removed_${a}", { a: that.t("plan") }, "capital"),
            duration: 5000,
            closeable: true,
            icon: "fi fi-trash",
          });
        },
      });
    }

    return false;
  },

  _edit() {
    const ids =
      this.model.get("type") === "network"
        ? [getContingentPlanNetworkId(this.model)]
        : getContingentPlanContingentIds(this.model);

    this.triggered = true;

    this.getOption("plantoolView").editPlan({
      type: this.model.get("type"),
      date: moment(this.model.get("date")),
      id: ids,
    });
  },

  _toggle(target) {
    $("#" + $(target.currentTarget).data("inb-toggle")).toggleClass("hide");
    this.$el.toggleClass("toggled");
  },
});

const PlantoolSidebar = InboomaBaseView.extend({
  template: PlantoolSidebarTpl,
  el: "#inb-c-sidebar",

  behaviors: [
    {
      behaviorClass: SidebarFilterBehavior,
      filterMap: {
        network: (view, filterVal) => {
          view.collection.filterByNetwork(filterVal);
          Radio.channel("app").trigger("plantool-items:filter", {
            network_id: parseInt(filterVal),
          });
        },
      },
      unselectFilter: (filter) => {
        Radio.channel("app").trigger("plantool-items:filter", { network_id: null });
      },
      unselectAllFilter: () => {
        Radio.channel("app").trigger("plantool-items:filter", { network_id: null });
      },
    },
  ],

  templateContext() {
    let networks = this.getOption("isNetworkPlan")
      ? Radio.channel("networks").request("get:data")
      : [];

    return {
      isNetworkPlan: this.getOption("isNetworkPlan"),
      networks,
      client_id: Biscuit.get("user.client_id"),
    };
  },

  initialize() {
    this.render();
  },
});

const PlantoolSortTabs = InboomaBaseView.extend({
  template: PlantoolSortTabsTpl,
  el: "#inb-c-main-sort-nav",

  templateContext() {
    let bookingAbleText = this.t("booking_able", null, "capital");
    let availableText = this.t("available_prev_day", null, "capital");
    let pickups = this.t("pickups", null, "capital");
    let availableNewText = this.t("available_prev_day", null, "capital");
    if (
      this.getOption("isNetworkPlan") &&
      activePlanData &&
      typeof activePlanData.valid_from !== "undefined"
    ) {
      let tomorrow = activePlanData.valid_from.toDate();
      let dayBeforeTomorrow = new Date(tomorrow) - 1;
      bookingAbleText =
        this.t("booking_able", null, "capital") + " " + moment(tomorrow).format("DD.MM.YYYY");
      availableText =
        this.t("available_prev_day", null, "capital") +
        moment(dayBeforeTomorrow).format("DD.MM.YYYY");
      pickups = this.t("pickups", null, "capital") + " " + moment(tomorrow).format("DD.MM.YYYY");
      availableNewText =
        this.t("available_prev_day", null, "capital") + moment(tomorrow).format("DD.MM.YYYY");
    }
    return {
      isNetworkPlan: this.getOption("isNetworkPlan"),
      targetPlanIsEmpty: activePlanData === null,
      bookingAbleText: bookingAbleText,
      availableText: availableText,
      pickups: pickups,
      availableNewText: availableNewText,
    };
  },

  initialize() {
    this.render();
  },

  onRender() {
    // https://foundation.zurb.com/sites/docs/sticky.html
    Foundation.Sticky.defaults.marginTop = 0;
    new Foundation.Sticky(this.$el);
  },
});

export default InboomaBaseCollectionView.extend({
  collectionEmptyTpl: appPlantoolCollectionEmptyTpl,
  childView: PlantoolViewItemList,
  el: "#inb-c-main-contingents",

  ui: {
    closeEditViewBtn: ".inb-plantool-contingents-edit-close-btn",
  },

  events: {
    "click @ui.closeEditViewBtn": "_closeEditViewBtn",
  },

  template: `
    <!-- #inb-plantool-form-modal -->
    <div
     id="inb-plantool-form-modal"
     class="reveal small"
     data-reveal
     data-close-on-click="true"
     data-animation-in="fade-in"
     data-animation-out="fade-out">

      <header class="inb-header off-canvas__header row clearfix">
        <h1 class="inb-page-title">
          <% if (isNetworkPlan) { %>
            <%= t('networkPlans',null,'capital') %>
          <% } else { %>
            <%= t('contingentPlans',null,'capital') %>
          <% } %>
        </h1>
        <div class="off-canvas__actions medium-6 column">
          <button 
          type="button"
          class="float-right button hollow secondary right button-abort round"
          title="cancel"
          data-close="">
              <i class="fi fi-x"></i>
          </button>
        </div>
      </header>
      
      <p class="hide off-canvas__form-error fi fi-alert"></p> 

      <form method="POST" action="#">
        <div
        id="inb-plantool-form-modal__content"
        class="row"></div>
      </form>
    </div>
    <!-- /#inb-plantool-form-modal -->
    <div class="sub-plan-view">
    
    </div>
    <% if (!targetPlanIsEmpty) { %>
    <h3 class="column clearfix" style="padding-top:14px;font-size:1.7rem;">
      <% if (currentNetworkName) { %>
      <span class="column"><%= currentNetworkName %></span>
      <% } %>
      <button type="button" class="button hollow secondary right round inb-plantool-contingents-edit-close-btn" title="<%= t('back',null,'capital') %>">
        <i class="fi fi-x"></i>
      </button>
    </h3>
    <% } %>`,

  templateContext() {
    let networks = Radio.channel("networks").request("get:data");

    let currentNetwork =
      this.getOption("isNetworkPlan") && activePlanData && networks._byId[activePlanData.network_id]
        ? networks._byId[activePlanData.network_id]
        : null;

    return {
      targetPlanIsEmpty: activePlanData === null,
      collectionIsEmpty: this.collection.length === 0,
      isNetworkPlan: this.getOption("isNetworkPlan"),
      currentNetworkName: currentNetwork ? currentNetwork.get("name") : null,
      client_id: Biscuit.get("user.client_id"),
    };
  },

  childViewOptions() {
    return {
      plantoolView: this,
      isNetworkPlan: this.getOption("isNetworkPlan"),
      networkId: activePlanData ? activePlanData.network_id : null,
    };
  },
  removeEventListener() {
    this.collection._superset.off("add");
    this.collection._superset.off("change");
  },

  _targetPlan: {},

  _softCloseNotification() {
    // Close notification WITHOUT calling .close()
    // to avoid side effects such as re-rendering of whole collectionView
    document.getElementById("inb-notifications").innerHTML = "";
    this._targetPlan = {};
    delete this._notification;
  },

  _closeEditViewBtn() {
    const contingentPlans = Radio.channel("contingentPlans").request("get:data"),
      that = this;

    contingentPlans._pagination.current_page = 0;
    that.collection = contingentPlans;
    activePlanData = null;

    that.sidebar.model = new Backbone.Model();
    that.sidebar.render();
    that.sortTabs.render();

    that.render();
  },

  _submitTargetPlan() {
    const that = this,
      plan = {
        plan: {},
      };

    let c = 0;

    _.each(this._targetPlan, (contingents, location_id) => {
      const items = [];

      let valid_from = null;
      let network_id = null;

      _.each(contingents, (contingentPlanItem, contingent_id) => {
        valid_from =
          typeof contingentPlanItem.valid_from !== "undefined"
            ? contingentPlanItem.valid_from
            : activePlanData.valid_from.format("YYYY-MM-DD HH:mm:ss");

        network_id = contingentPlanItem.network_id ? contingentPlanItem.network_id : network_id;

        items.push({
          ...contingentPlanItem,
          valid_from,
        });
      });

      plan.plan[c++] = {
        // c++ hihi ^^
        location_id: Number(location_id),
        date: valid_from,
        client_id: Number(Biscuit.get("user.client_id")),
        type: that.getOption("isNetworkPlan") ? "network" : "contingent",
        items,
        network_id:
          that.getOption("isNetworkPlan") &&
          activePlanData &&
          typeof activePlanData.network_id !== "undefined"
            ? activePlanData.network_id
            : network_id
              ? network_id
              : null,
      };
    });

    const postTargetPlan = new Backbone.Model(plan);

    postTargetPlan.urlRoot = "/contingent_plans";

    postTargetPlan.save(null, {
      success() {
        that._softCloseNotification();

        new Notification({
          message: that.t("saved_${a}", { a: that.t("contingent_changes") }),
          closeable: true,
          duration: 6000,
        });

        const contingentPlans = Radio.channel("contingentPlans").request("get:data");

        contingentPlans._pagination.current_page = 0;

        contingentPlans.fetch({
          success(__, response) {
            // Render index

            contingentPlans.reset(response.data);
            that.collection = contingentPlans;
            activePlanData = null;

            that.sidebar.model = new Backbone.Model();
            that.sidebar.render();
            that.sortTabs.render();

            that.render();
          },
        });
      },
      error(model, response) {
        let message = that.t("error", null, "capital");
        if (typeof response.responseJSON !== "undefined") {
          const data = response.responseJSON.data;
          if (typeof data !== "undefined" && typeof data.message !== "undefined") {
            message = data.message;
          }
        }
        new Notification({
          message: message,
          closeable: true,
          type: "warning",
          icon: "fi fi-check",
          duration: 6000,
        });
      },
    });
  },

  /**
   * Remove an item from target plan. If no contingent_id is provided,
   * whole selection for that location will be unset.
   *
   * Closes notification if no plan items are given anymore.
   *
   * @param {Number} location_id
   * @param {Number} contingent_id Optional
   */
  removeTargetPlanItem(location_id, contingent_id = null) {
    if (typeof this._targetPlan[location_id] !== "undefined") {
      if (contingent_id) {
        if (typeof this._targetPlan[location_id][contingent_id] !== "undefined") {
          delete this._targetPlan[location_id][contingent_id];
        }

        if (_.size(this._targetPlan[location_id]) === 0) {
          delete this._targetPlan[location_id];
        }
      } else {
        delete this._targetPlan[location_id];
      }
    }

    if (_.size(this._targetPlan) === 0 && typeof this._notification !== "undefined") {
      this._softCloseNotification();
    }
  },

  /**
   * Add a target plan item and provide a submit form notification.
   *
   * @param {Number} location_id
   * @param {Number} contingent_id
   * @param {Object} item
   */
  setTargetPlanItem(location_id, contingent_id, item) {
    if (typeof this._targetPlan[location_id] === "undefined") {
      this._targetPlan[location_id] = {};
    }

    delete item.isSavedItem;

    this._targetPlan[location_id][contingent_id] = item;

    if (typeof this._notification === "undefined") {
      const that = this;

      this._notification = new Notification({
        message: `<%= t('plan_notification_title') %>
                      <a
                       href="#"
                       class="plantool-notification__submit">
                        <%= t('save',null,'capital') %>
                      </a>
                     <a
                      href="#"
                      class="plantool-notification__reset">
                        | <%= t('reset_changes') %>
                     </a>
                    `,
        classes: "plantool-notification",
        icon: "fi fi-clipboard-pencil",
        closeable: true,
        customEvents: {
          "click .plantool-notification__reset": () => {
            that._notification.close();
          },
          "click .plantool-notification__submit": () => {
            that._submitTargetPlan();
          },
        },
        onClose: () => {
          // Unset state, re-render list using the "old" data
          that._targetPlan = {};
          delete that._notification;
          that.render();
        },
      });
    }
  },

  initialize() {
    window.requestAnimationFrame(() => {
      // When coming from "contingents" view, a load more button may remain in DOM
      // (out of scope of this.el). @see #21533 #3
      const remainingLoadMoreBtn = document.querySelector(".inb-next-page-button");
      if (remainingLoadMoreBtn) {
        remainingLoadMoreBtn.remove();
      }
    });

    this.sidebar = new PlantoolSidebar({
      collection: this.collection.proxy,
      model: ContingentPlan,
      controller: this,
      isNetworkPlan: this.getOption("isNetworkPlan"),
    });

    this.sortTabs = new PlantoolSortTabs({
      isNetworkPlan: this.getOption("isNetworkPlan"),
    });

    this.collection.comparator = (itemA, itemB) => {
      let dateA = +new Date(itemA.get("date"));
      let dateB = +new Date(itemB.get("date"));
      return [dateA > dateB ? -1 : 1];
    };

    this.collection.sort();

    this.render();

    const that = this;

    this.collection.on("reset", () => {
      that._checkForEmptyCollection();
    });

    const appChannel = Radio.channel("app"),
      onRouterExecute = function (from, to) {
        if (typeof that._notification !== "undefined") {
          that._softCloseNotification();
        }

        if (!to.controllerMethod.startsWith("plantool")) {
          // Remove all dead pikaday's...
          $(".pika-single").remove();
        }

        activePlanData = null;

        appChannel.off("router:execute", onRouterExecute);
      };

    appChannel.on("router:execute", onRouterExecute);
  },

  onRender() {
    if (!this.getOption("isNetworkPlan")) {
      $(".is-selected-location")
        .first()
        .closest(".inb-c-item")
        .before(
          '<p style="text-align:center"><strong>' +
            this.t("choosen_contingents", null, "capital") +
            "</strong></p>",
        );
      $(".is-selected-location")
        .last()
        .closest(".inb-c-item")
        .after(
          '<hr /><p style="text-align:center"><strong>' +
            this.t("chooseable_contingents", null, "capital") +
            "</strong></p>",
        );
    }
  },

  openForm() {
    if (typeof this._notification !== "undefined") {
      this._notification.close();
    }

    this.plantoolForm = new PlantoolForm({
      el: document.getElementById("inb-plantool-form-modal"),
      plantoolCollectionView: this,
      plantoolSidebarView: this.sidebar,
      plantoolSortTabs: this.sortTabs,
      isNetworkPlan: this.getOption("isNetworkPlan"),
    });
  },

  _fetchPlanRequestInProgress: false,

  editPlan(options) {
    if (this._fetchPlanRequestInProgress) return;

    this._fetchPlanRequestInProgress = true;

    activePlanData = {
      contingents_text: "",
      date: options.date,
      valid_from: options.date,
      valid_to: options.date.clone().add(1, "day"),
    };

    if (options.type === "network") {
      activePlanData.network_id = options.id[0];
    }

    const RequestModel = Backbone.Model.extend({
      url: "/contingent_plans/getPlan",
    });

    const requestModel = new RequestModel({
      ...options,
      date: options.date.format("YYYY-MM-DD HH:mm:ss"),
    });

    const that = this;

    requestModel.save(null, {
      type: "POST",
      success(__, data) {
        let plan = data.plan;

        if (!that.getOption("isNetworkPlan")) {
          plan = plan.avail_to_change;
        }

        new Notification({
          message: that.t("generated_plan_${entries_length}", { entries_length: plan.length }),
          duration: 6000,
          type: "success",
          icon: "fi fi-list",
          closeable: true,
        });

        // activePlanData.location_id = plan[0].location;

        let planCollection = new ContingentPlans();
        if (!that.getOption("isNetworkPlan")) {
          _.each(plan, function (_plan, key) {
            let isSelectedLocation = false;

            _.each(_plan.items, function (_item) {
              if (_.contains(options.id, _item.contingent_id)) {
                isSelectedLocation = true;
              }
            });

            if (isSelectedLocation) {
              _plan.isSelectedLocation = true;
              planCollection.add(_plan);
            }
          });
          _.each(plan, function (_plan, key) {
            let isSelectedLocation = false;

            _.each(_plan.items, function (_item) {
              if (_.contains(options.id, _item.contingent_id)) {
                isSelectedLocation = true;
              }
            });

            if (!isSelectedLocation) {
              _plan.isSelectedLocation = false;
              planCollection.add(_plan);
            }
          });
        } else {
          planCollection = new ContingentPlans(plan);
          _.each(planCollection.models, function (planModel) {
            // Sort: Move items to the first place that regard any of the selected locations
            _.each(plan, function (_plan, key) {
              if (_plan.location === planModel.get("location")) {
                const _planModel = planModel.toJSON();

                planModel.destroy();
                planCollection.unshift(_planModel);
              }
            });
          });
        }

        that.collection = planCollection;
        that.render();

        that.sortTabs.render();

        data.activePlanData = activePlanData;

        that.sidebar.model = new Backbone.Model(data);
        that.sidebar.render();

        that._fetchPlanRequestInProgress = false;
      },
      error() {
        alert(that.t("error_general_error"));
        that._fetchPlanRequestInProgress = false;
      },
    });
  },
});

const PlantoolForm = InboomaBaseView.extend({
  template: _.noop,
  _fetchPlanRequestInProgress: false,

  fetchPlan(options) {
    if (this._fetchPlanRequestInProgress) return;

    this._fetchPlanRequestInProgress = true;

    const that = this;

    const RequestModel = Backbone.Model.extend({
      url: "/contingent_plans/getPlan",
    });

    const requestModel = new RequestModel(options);

    requestModel.save(null, {
      type: "POST",
      success(__, data) {
        let plan = data.plan;

        if (!that.getOption("isNetworkPlan")) {
          plan = plan.avail_to_change;
        }

        new Notification({
          message: that.t("generated_plan_${entries_length}", { entries_length: plan.length }),
          duration: 6000,
          type: "success",
          icon: "fi fi-list",
          closeable: true,
        });

        //activePlanData = plan[0];
        let planCollection = new ContingentPlans();
        if (!that.getOption("isNetworkPlan")) {
          _.each(plan, function (_plan, key) {
            let isSelectedLocation = false;

            _.each(_plan.items, function (_item) {
              if (_.contains(options.id, _item.contingent_id)) {
                isSelectedLocation = true;
              }
            });

            if (isSelectedLocation) {
              _plan.isSelectedLocation = true;
              planCollection.add(_plan);
            }
          });
          _.each(plan, function (_plan, key) {
            let isSelectedLocation = false;

            _.each(_plan.items, function (_item) {
              if (_.contains(options.id, _item.contingent_id)) {
                isSelectedLocation = true;
              }
            });

            if (!isSelectedLocation) {
              _plan.isSelectedLocation = false;
              planCollection.add(_plan);
            }
          });
        } else {
          planCollection = new ContingentPlans(plan);
          _.each(planCollection.models, function (planModel) {
            // Sort: Move items to the first place that regard any of the selected locations
            _.each(plan, function (_plan, key) {
              if (_plan.location === planModel.get("location")) {
                const _planModel = planModel.toJSON();

                planModel.destroy();
                planCollection.unshift(_planModel);
              }
            });
          });
        }
        that.getOption("plantoolCollectionView").collection = planCollection;

        that.getOption("plantoolCollectionView").render();

        that.getOption("plantoolSortTabs").render();

        data.activePlanData = activePlanData;

        that.getOption("plantoolSidebarView").model = new Backbone.Model(data);

        that.getOption("plantoolSidebarView").render();

        that.$el.trigger("close");

        that._fetchPlanRequestInProgress = false;
      },
      error() {
        alert(that.t("error_general_error"));
        that._fetchPlanRequestInProgress = false;
      },
    });
  },

  initialize() {
    this.render();
  },

  onRender() {
    /**
     * As of now, valid_from-time will always be 00:00:00
     */

    let networks = [];

    const that = this,
      contingents = Radio.channel("contingents").request("get:data");

    const getContingentLabel = (contingent) => {
      if (typeof contingent.toJSON !== "undefined") {
        contingent = contingent.toJSON();
      }

      return (
        contingent.name +
        FormatHelper.formatContingentTags(contingent.tags) +
        (contingent.locations && contingent.locations.length
          ? " - " + contingent.locations[0].name
          : "")
      );
    };

    const formModel = new Backbone.Model({
      date: moment().format("YYYY-MM-DD") + " 00:00:00",
      network_id: null,
      contingent_ids: [],
    });

    if (this.getOption("isNetworkPlan")) {
      networks = Radio.channel("networks").request("get:data");

      if (networks.models.length >= 1) {
        formModel.set("network_id", [{ id: networks.models[0].get("id") }]);
      }
    }

    // Ready... steady... build form!
    const formModal = new Foundation.Reveal(this.$el),
      fields = [
        {
          name: "date",
          control: "datepicker",
          label: this.t("date"),
          size: {
            large: "4",
          },
        },
        {
          name: "network_id",
          control: "selector",
          label: this.t("network"),
          options: _.map(networks.models, (network) => ({
            value: network.get("id"),
            label: network.get("name"),
          })),
          size: {
            large: "6",
          },
          visible: this.getOption("isNetworkPlan"),
        },
        {
          name: "contingent_ids",
          control: "selector",
          hasMultiple: () => 999,
          label: this.t("contingents"),
          options: _.map(contingents.models, (contingent) => ({
            value: contingent.get("id"),
            label: getContingentLabel(contingent),
          })),
          extraTopClasses: ["select2-show-search-input"],
          select2Options: {
            rememberSearch: true,
            closeOnSelect: false,
            /*sorter (itemList) { 
                      return _.sortBy(itemList, (item) => {
                        console.log(item);
                        return item.text.startsWith('bike');
                      });
                   },*/
            ajax: {
              url: getApiHost() + "/contingents",
              headers: getRequestHeaders(),
              dataType: "json",
              delay: 0,
              data: (params) => ({
                q: params.term,
                sort: "name",
                page: params.page,
                limit: 50,
              }),
              processResults: (data, params) => ({
                results: _.map(data.data, (item) => ({
                  id: item.id,
                  text: getContingentLabel(item),
                })),
                pagination: {
                  more: data.pagination.has_next_page,
                },
              }),
            },
            minimumInputLength: 0,
            casesensitive: false,
          },
          size: {
            large: "8",
          },
          visible: !this.getOption("isNetworkPlan"),
        },
        {
          control: "spacer",
        },
        {
          control: "button",
          label: this.t("generate", null, "capital"),
          size: {
            large: "3",
          },
        },
      ],
      form = new Backform.Form({
        el: document.getElementById("inb-plantool-form-modal__content"),
        fields,
        model: formModel,
        events: {
          "click button[type='submit']": (ev) => {
            const ids = that.getOption("isNetworkPlan")
              ? formModel.get("network_id")
              : formModel.get("contingent_ids");

            const type = that.getOption("isNetworkPlan") ? "network" : "contingent";

            if (ids === null) {
              alert(
                that.t("no_${a}_selected", {
                  a: that.getOption("isNetworkPlan") ? that.t("networks") : that.t("networks"),
                }),
              );
              return false;
            }

            that.$('button[type="submit"]').prepend(appRollingLoaderAnim);

            const date = moment(formModel.get("date"));

            let contingents_text = "";

            if (that.getOption("isNetworkPlan")) {
              // Select field
              contingents_text = that
                .$(".inb-form-group.network_id .select2-selection__rendered")
                .html();
            } else {
              // Multiselect field
              _.each(
                that.$(".inb-form-group.contingent_ids li.select2-selection__choice"),
                (li, c) => {
                  contingents_text += (c >= 1 ? ", " : "") + li.getAttribute("title");
                },
              );
            }

            activePlanData = {
              contingents_text,
              date,
              valid_from: date,
              valid_to: date.clone().add(1, "day"),
            };

            if (that.getOption("isNetworkPlan")) {
              activePlanData.network_id = Number(formModel.get("network_id")[0].id);
            }

            that.fetchPlan({
              type,
              date: date.format("YYYY-MM-DD HH:mm:ss"),
              id: _.map(ids, (_id) => Number(_id.id)),
            });

            return false;
          },
        },
      }).render();

    formModal.open();

    this.$el.on("closed.zf.reveal", () => {
      Radio.channel("app").trigger("destroy:backform"); // Remove pikaday from DOM

      that.$el.html("");

      Backbone.history.navigate(
        that.getOption("isNetworkPlan") ? "network_plans" : "contingent_plans",
      );

      that.$el.off("closed.zf.reveal");
    });
  },
});

export const getContingentPlanNetworkId = (obj) => {
  let contingentPlanItems = obj.get("contingent_plan_items");

  if (typeof contingentPlanItems === "undefined" || typeof contingentPlanItems[0] === "undefined") {
    return null;
  }

  return contingentPlanItems[0].network_id;
};

export const getContingentPlanContingentIds = (obj) => {
  let contingentPlanItems = obj.get("contingent_plan_items");

  if (typeof contingentPlanItems === "undefined" || typeof contingentPlanItems[0] === "undefined") {
    return null;
  }
  let contingentIds = [];
  _.each(contingentPlanItems, function (item) {
    contingentIds.push(item.contingent_id);
  });
  return contingentIds;
};
